var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeSocial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    style: {
      borderRadius: 7
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8429 12.15L20.6429 16.0143L13.8429 19.8786V12.15ZM32.5 3.42857V28.5714C32.5 30.4643 30.9643 32 29.0714 32H3.92857C2.03571 32 0.5 30.4643 0.5 28.5714V3.42857C0.5 1.53571 2.03571 0 3.92857 0H29.0714C30.9643 0 32.5 1.53571 32.5 3.42857ZM29.5 16.0214C29.5 16.0214 29.5 11.7643 28.9571 9.72143C28.6571 8.59286 27.7786 7.70714 26.6571 7.40714C24.6357 6.85714 16.5 6.85714 16.5 6.85714C16.5 6.85714 8.36429 6.85714 6.34286 7.40714C5.22143 7.70714 4.34286 8.59286 4.04286 9.72143C3.5 11.7571 3.5 16.0214 3.5 16.0214C3.5 16.0214 3.5 20.2786 4.04286 22.3214C4.34286 23.45 5.22143 24.3 6.34286 24.6C8.36429 25.1429 16.5 25.1429 16.5 25.1429C16.5 25.1429 24.6357 25.1429 26.6571 24.5929C27.7786 24.2929 28.6571 23.4429 28.9571 22.3143C29.5 20.2786 29.5 16.0214 29.5 16.0214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSocial);
export default __webpack_public_path__ + "static/media/youtube-social.180dbf9a62e30f9ae3967aac8baf8566.svg";
export { ForwardRef as ReactComponent };